import { Component, useContext } from "react";
import AuthService from "../store/AuthService";
import React from "react";

type AuthProps = {
    children: React.ReactNode
}

const AuthContext = React.createContext<AuthService | null>(null);

const useAuth = () => useContext(AuthContext);

export const AuthConsumer = AuthContext.Consumer;

class AuthProvider extends Component<AuthProps, {}> {
    authService;
    constructor(props: AuthProps) {
        super(props);
        this.authService = new AuthService();
    }
    render() {
        return <AuthContext.Provider value={this.authService}>{this.props.children}</AuthContext.Provider>;
    }
}

export { AuthProvider, useAuth };


